export const FETCH_FEE_TYPE_REQUEST = "FETCH_FEE_TYPE_REQUEST";
export const FETCH_FEE_TYPE_SUCCESS = "FETCH_FEE_TYPE_SUCCESS";
export const FETCH_FEE_TYPE_FAILURE = "FETCH_FEE_TYPE_FAILURE";

export const FETCH_ALL_FEE_REQUEST = "FETCH_ALL_FEE_REQUEST";
export const FETCH_ALL_FEE_SUCCESS = "FETCH_ALL_FEE_SUCCESS";
export const FETCH_ALL_FEE_FAILURE = "FETCH_ALL_FEE_FAILURE";

export const FETCH_FEE_REQUEST = "FETCH_FEE_REQUEST";
export const FETCH_FEE_SUCCESS = "FETCH_FEE_SUCCESS";
export const FETCH_FEE_FAILURE = "FETCH_FEE_FAILURE";

export const UPDATE_FEE_REQUEST = "UPDATE_FEE_REQUEST";
export const UPDATE_FEE_SUCCESS = "UPDATE_FEE_SUCCESS";
export const UPDATE_FEE_FAILURE = "UPDATE_FEE_FAILURE";

export const CREATE_FEE_REQUEST = "CREATE_FEE_REQUEST";
export const CREATE_FEE_SUCCESS = "CREATE_FEE_SUCCESS";
export const CREATE_FEE_FAILURE = "CREATE_FEE_FAILURE";

export const ACTIVATE_OR_DEACTIVATE_FEE_REQUEST =
  "ACTIVATE_OR_DEACTIVATE_FEE_REQUEST";
export const ACTIVATE_OR_DEACTIVATE_FEE_SUCCESS =
  "ACTIVATE_OR_DEACTIVATE_FEE_SUCCESS";
export const ACTIVATE_OR_DEACTIVATE_FEE_FAILURE =
  "ACTIVATE_OR_DEACTIVATE_FEE_FAILURE";

export const DELETE_FEE_REQUEST = "DELETE_FEE_REQUEST";
export const DELETE_FEE_SUCCESS = "DELETE_FEE_SUCCESS";
export const DELETE_FEE_FAILURE = "DELETE_FEE_FAILURE";

export const GET_OUTSTANDING_ALUMNI_FEE_REQUEST =
  "GET_OUTSTANDING_ALUMNI_FEE_REQUEST";
export const GET_OUTSTANDING_ALUMNI_FEE_SUCCESS =
  "GET_OUTSTANDING_ALUMNI_FEE_SUCCESS";
export const GET_OUTSTANDING_ALUMNI_FEE_FAILURE =
  "GET_OUTSTANDING_ALUMNI_FEE_FAILURE";
